import React from 'react';
import * as Sentry from '@sentry/react';
import { createRoutesFromChildren, matchRoutes, Routes, useLocation, useNavigationType } from 'react-router-dom';

const deployEnv = import.meta.env.VITE_DEPLOY_ENV;

let SentryRoutes = Routes;

function initializeSentry() {
  if (deployEnv === 'production') {
    Sentry.init({
      dsn: 'https://bfc9395fd482cfb032140867bdcd9b92@o4507695731965952.ingest.de.sentry.io/4507695737471056',
      environment: import.meta.env.VITE_DEPLOY_ENV,
      integrations: [
        Sentry.reactRouterV6BrowserTracingIntegration({
          useEffect: React.useEffect,
          useLocation,
          useNavigationType,
          createRoutesFromChildren,
          matchRoutes,
        }),
      ],
      tracesSampleRate: 1.0,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
    });

    SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);
  } else {
    console.debug('Sentry is disabled in development mode');
    SentryRoutes = Routes;
  }
}

function sendMessageToSentry(message: string) {
  Sentry.captureMessage(message);
}

export { initializeSentry, SentryRoutes, sendMessageToSentry };
